import React, { FC } from "react";
import styled from "@emotion/styled";
import ACheckbox, { CheckboxProps } from "@atlaskit/checkbox";

const StyledCheckbox = styled(ACheckbox)`
  & ~ span {
    font-size: 14px;
    font-weight: 400;
  }
`;

export const Checkbox: FC<CheckboxProps & any> = React.forwardRef((props, ref) => (
  <StyledCheckbox {...(props as any)} ref={ref} />
));

export type { CheckboxProps };
